import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M56.36 11.76C50.95 5 38.74 1 31.64 1C24.54 1 12.22 5 6.81002 11.76C-2.87998 23.87 3.73002 50.51 3.73002 50.51C3.73002 50.51 4.39003 28.93 11.66 22.55C17.85 17.11 23.53 19.2 31.59 19.2C39.65 19.2 45.33 17.12 51.52 22.55C58.79 28.94 59.45 50.51 59.45 50.51C59.45 50.51 66.05 23.87 56.36 11.76Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M25.02 1.58008C25.02 1.58008 22.54 7.19008 26.01 19.2501"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path d="M17.42 4.05005C17.42 4.05005 13.46 10.3301 16.43 19.7401" stroke={outline} strokeMiterlimit="10" />
      <path
        d="M13.9501 5.87012C13.9501 5.87012 8.67008 11.3201 10.8101 22.8801"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M6.47001 11.76C6.47001 11.76 0.910012 23.04 5.86001 34.77"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M38.16 1.58008C38.16 1.58008 40.64 7.19008 37.17 19.2501"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path d="M45.75 4.05005C45.75 4.05005 49.71 10.3301 46.74 19.7401" stroke={outline} strokeMiterlimit="10" />
      <path
        d="M49.2201 5.87012C49.2201 5.87012 54.5001 11.3201 52.3601 22.8801"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M56.7101 11.76C56.7101 11.76 62.2701 23.04 57.3201 34.77"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
    </g>
  )
}
